export enum ProductCategory {
	Line,
	Virtual,
	ManualBillItem
}